import styled from "styled-components";

export const EWarrantyContainerStyled = styled.div`
  .filter_layout {
    margin-bottom: 2rem;
  }
  .body_layout {
  }
`;
